<template>
  <input
    class="form-control lar_input"
    :id ="id"
    :class="{
      'is-invalid': hasError
    }"
    :type="type"
    :placeholder="placeholder"
    @input.prevent="$emit('input', $event.target.value)"
    @click="$emit('click', $event)"
    @focus="$emit('focus', $event)"
  >
</template>
<script>
export default {
  name: 'FormInput',
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: value =>
        ['text', 'number', 'password', 'email', 'tel', 'url'].indexOf(value) !== -1
    },
    placeholder: {
      type: String,
      default: ''
    },
    hasError: Boolean
  }
}
</script>
<style lang="scss" scoped>
.lar_input {
    color: black;
}
</style>
